import { ITreeOption } from '@/types';
import { hasNestedItems } from './Folders.utils';

/** Закрепить можно ссылку без детей, кроме главной. */
export function canPinMenuNode(node: ITreeOption) {
    return Boolean(node.url && node.url.split(/[?#]/)[0] !== '/' && !hasNestedItems(node));
}

/** Legacy servers do not expose groupId. Explicit server grouping always wins. */
export function withDefaultMenuGroups(items: ITreeOption[]): ITreeOption[] {
    if (items.some((item) => item.groupId != null)) return items;
    let groupId = 'work';
    return items.map((item) => {
        const value = String(item.value).toLowerCase();
        if (value.startsWith('reports/') || value.startsWith('dashboards/')) {
            groupId = 'control';
        } else if (value.startsWith('dictionaries/') || value === 'administrations') {
            groupId = 'system';
        } else if (value.startsWith('tasks/') || value.startsWith('documents/') || item.url === '/') {
            groupId = 'work';
        }
        return { ...item, groupId };
    });
}
